import { RESET_ALL_STATES } from '../actions/actions';


import {
    CARD_PROCESSOR_DATA_REQUEST ,
    CARD_PROCESSOR_DATA_SUCCESS, 
    CARD_PROCESSOR_DATA_FAILURE, 
  } from '../actions/actionTypes';
  

const initialState = {
  isLoading: false,
  error: null,
  data: null, 
};

const cardProcessorDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case CARD_PROCESSOR_DATA_REQUEST:
      return { ...state, isLoading: true, error: null };
    case CARD_PROCESSOR_DATA_SUCCESS:
      return { ...state, isLoading: false, data: action.payload };
    case CARD_PROCESSOR_DATA_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
      case RESET_ALL_STATES:
        return initialState;
      default:
      return state;
  }
};

export default cardProcessorDataReducer;

  